module.exports = __webpack_public_path__ + "static/30-dde51914c83e40226241a6180895a501.png";